export const Avatar = (props:{delegate:any, className:string}) => {
    return (
        <img onClick={() => window.location.href =`/delegates/${props.delegate.username}`} src={props.delegate.avatar? props.delegate.avatar : "/default_avatar.png"} className={`rounded-full border border-gray-200 dark:border-dark-secondary cursor-pointer ${props.className}`} alt="" />
    );
}
